<script lang="ts">
	import type { ComponentType } from '$lib/types/props';
	import ProjectHeaderInfo from '../elements/ProjectHeaderInfo.svelte';
	import { t } from 'svelte-i18n';
	import { formatAmountWithCurrency } from '$lib/utils/strings';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectHeader from '../ProjectHeader.svelte';
	import { OperationCategoryEnum } from '@app/models/api/enums/OperationCategoryEnum';
	import { OperationStatusEnum } from '@app/models/api/enums/OperationStatusEnum';
	import {
		createFinancialInstrumentHeaderComponent,
		getOperationModelAmountNeeded
	} from '@app/utils/operations';
	export let operation: OperationModel;
	let isMinAmountReached = operation.amountCollected >= operation.amountNeededMin;
	let headerComponents: ComponentType[] = [];

	let rateInformationsProps = operation?.isVariableRate
		? {
				label: $t('operation.headers.triCible'),
				value: `${operation.triCible}%`
			}
		: {
				label: $t('operation.headers.annualInterest'),
				value: `${operation.percentBondYield}%`
			};

	!operation.status?.includes(OperationStatusEnum.VOTE) &&
		(headerComponents = [
			{
				component: ProjectHeaderInfo,
				props: {
					label: isMinAmountReached ? '' : $t('operation.headers.objectives'),
					value:
						getOperationModelAmountNeeded(operation) <= operation.amountCollected
							? $t('operation.headers.goalAmountReached')
							: isMinAmountReached
								? $t('operation.headers.minAmountReached')
								: formatAmountWithCurrency(operation.amountNeededMin),
					classNames: isMinAmountReached ? 'text-success' : ''
				}
			},
			{
				component: ProjectHeaderInfo,
				props: rateInformationsProps
			},
			{
				component: ProjectHeaderInfo,
				props: {
					label: $t('operation.headers.outingsHorizon'),
					value: `${operation.outingsHorizon} ${$t('date.months')}`
				}
			},
			createFinancialInstrumentHeaderComponent(operation)
		]);

	operation.category === OperationCategoryEnum.REAL_ESTATE &&
		headerComponents.push({
			component: ProjectHeaderInfo,
			props: {
				label: $t('decisionTool.altName'),
				value: operation.scoringGlobal,
				hint: $t('decisionTool.html')
			}
		});
</script>

<ProjectHeader components={headerComponents} />
